import { withWindow } from '@shared/utils/withWindow';
import React, { useMemo } from 'react';
import { IntercomContext } from './context';
import type { IntercomAlignment, IntercomService } from './service';

export const IntercomProvider: React.FC<{ intercom: IntercomService }> = ({ intercom, children }) => {
  const value = useMemo(() => {
    return {
      show: (message?: string) => {
        intercom.show(message);
      },
      hide: () => {
        intercom.hide();
      },
      boot: (alignment?: IntercomAlignment) => {
        return new Promise<void>(res => {
          withWindow(window => {
            // eslint-disable-next-line compat/compat
            window.requestIdleCallback(() => {
              intercom.boot(alignment).then(res);
            });
          });
        });
      },
      shutdown: () => {
        intercom.shutdown();
      },
      showLauncher: (alignment?: IntercomAlignment) => {
        intercom.showLauncher(alignment);
      },
      hideLauncher: () => {
        intercom.hideLauncher();
      },
      startSurvey: (id: string) => {
        intercom.startSurvey(id);
      },
      identify: (idProps: { userId?: string; email?: string; name?: string }) => {
        intercom.identify(idProps);
      },
    };
  }, [intercom]);

  return <IntercomContext.Provider value={value}>{children}</IntercomContext.Provider>;
};
